import * as React from 'react'
import styled from 'styled-components'
import {devices} from '../../components/MediaQuerys/BreakpointsAndDevices'


// Page Container
const PageContainerComponent = styled.section`
    display: grid;
    justify-content: center;
    align-items: center;
    /* width: auto; */
    overflow-x: hidden;
    white-space: nowrap; 
    margin: 0;
    /* @media only screen and ${devices.mobileS} {
        width: 320px;
        
    }
    @media only screen and ${devices.mobileM} {
        width: 375px;
        
    }
    @media only screen and ${devices.tablet} {
        min-width: 768px;
    }
    @media only screen and ${devices.laptop}{
        width: 80%;
        

    }
    @media only screen and ${devices.laptopL}{
        width: 1440px;
         */

    
`
export const PageContainer = (props)=>{
    return(
        <PageContainerComponent>
            {props.children}
        </PageContainerComponent>
    )
}


